module.exports = __webpack_public_path__ + "img/ok.5846b93.png";